import React, { useEffect, useState } from 'react';
import { Table, Spin, Typography, InputRef, Input, Space, Button} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { formatNumberWithCommas, formatToTwoDecimalPlaces, rejectedApiMessage } from '../../utilities/CommonHelper';
import { fetchOBOReport_AllWOs } from '../../store/reducers/oboDashboardSlice';
import { ColumnType, FilterConfirmProps, TablePaginationConfig } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';


const { Title } = Typography;

interface DataType_woColumns {
    key: React.Key;
    woId: string;
    parentId: string;
    sumOfTCV: string;
    revenue: string;
    totalRevenue: string;
    obo: string;
  }
  type DataIndex_woColumns = keyof DataType_woColumns;

interface OboWODetailsTableContainerProps {
  parentSOW: any; // Parent opportunity data passed as props
}
const OboWODetailsTableContainer: React.FC<OboWODetailsTableContainerProps> = ({ parentSOW }) => {
    const dispatch = useDispatch();
    const oboReportsData = useSelector((state: any) => state.oboReports);
    const [woData, setwoData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [searchText, setSearchText] = React.useState('');
    const [searchedColumn, setSearchedColumn] = React.useState('');
    const searchInput = React.useRef<InputRef>(null);

    const [pageNo, setPageNo] = React.useState<number>(0);
    const [pageSize, setPageSize] = React.useState<number>(10);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [filters, setFilters] = React.useState<any>([]);
        
        
        const handleTableChange = (pagination: TablePaginationConfig,filters:any) => {
              const { current, pageSize } = pagination;
              const _current = current ? current - 1 : 0;
              setPageNo(_current);
              setPageSize(pageSize || 10);
              const _filters:any[] =[];
               Object.keys(filters).map((key) => {
                debugger;
                if(filters[key] && filters[key]!==undefined ){
          
                if(key==="woId"){
                  _filters.push({field:key,value:filters[key][0],operator:'EQUALS'});
                }
                else{
                  _filters.push({field:key,value:filters[key][0],operator:'LIKE'});
                }
                
                }
              })
              setFilters(_filters);
              dispatch(fetchOBOReport_AllWOs({
                'payload':{'sowId':parentSOW.sowid,'startDate':oboReportsData.filterData.startDate,'endDate': oboReportsData.filterData.endDate,
                  'page': _current,
                  'size': pageSize,
                  'filters':_filters
                }
                })).then((res:any) => {
                if(res.type!=="oboReports/fetchOBOReport_AllWOs/fulfilled"){
                    rejectedApiMessage(res.payload);
                    setLoading(false);
                }
                else{
                    let _temp = addkeytoData(res.payload.content);
                    setwoData(_temp);
                    setLoading(false);
                    setTotalCount(res.payload?.totalElements);
           		      setPageNo(_current);

                }

              }
           );
          };
    



      const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex_woColumns,
        ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
        };
        
        const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
        };
        const getColumnSearchProps = (dataIndex: DataIndex_woColumns): ColumnType<any> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
          <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
          >
          Search
          </Button>
          <Button
          onClick={() => {
          setSelectedKeys([]);
          handleSearch([], confirm, dataIndex);
          }}
          size="small"
          style={{ width: 90 }}
          >
          Reset
          </Button>
          </Space>
          </div>
        ),
        filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
          record[dataIndex] && record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
          <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        ),
        });
    

    const addkeytoData = (data:any) => {
		let tempData = [...data];
		tempData.map((item:any,index:number) => {
			item.key = index+1;
		});
		return tempData;
	}

    useEffect(() => {
        if (parentSOW && parentSOW.sowid && oboReportsData.filterData.startDate && oboReportsData.filterData.endDate) {
            fetchWoData();
        }
      }, [parentSOW,oboReportsData.filterData.startDate,oboReportsData.filterData.endDate]);
      
  const fetchWoData = async () => {
    setLoading(true);

    dispatch(fetchOBOReport_AllWOs({
            'payload':{'sowId':parentSOW.sowid,'startDate':oboReportsData.filterData.startDate,'endDate': oboReportsData.filterData.endDate,
              'page': 0,
              'size': 10,
              'filters':filters
            }
            })).then((res:any) => {
            if(res.type==="oboReports/fetchOBOReport_AllWOs/fulfilled"){
                    let _temp = addkeytoData(res.payload.content);
                    setwoData(_temp);
                    setTotalCount(res.payload?.totalElements);
                    setLoading(false);
            }
            else{
                rejectedApiMessage(res.payload);
                setLoading(false);
            }

        }
    );
}



const parentColumns = [
    {
      title: 'SOW ID',
      dataIndex: 'sowid',
      key: 'sowid',
    },
    {
      title: 'SOW Start Date',
      dataIndex: 'sowStartDate',
      key: 'sowStartDate',
    },
    {
        title: 'SOW End Date',
        dataIndex: 'sowEndDate',
        key: 'sowEndDate',
      },
    {
      title: 'Contract Value',
      dataIndex: 'sumOfTCV',
      key: 'sumOfTCV',
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
        )
        }
    },
    {
      title: 'Revenue For Period',
      dataIndex: 'revenue',
      key: 'revenue',
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
        )
        }
    },
    {
        title: 'Total Revenue',
        dataIndex: 'totalRevenue',
        key: 'totalRevenue',
        render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
        }
      },
      {
        title: 'OBO Value',
        dataIndex: 'obo',
        key: 'obo',
        render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
        }
      }
  ];

  const woColumns = [
    {
      title: 'Work Order ID',
      dataIndex: 'woId',
      key: 'woId',
      ...getColumnSearchProps('woId'),
    },
    {
      title: 'Parent ID',
      dataIndex: 'parentId',
      key: 'parentId',
    },
    {
      title: 'Total Contract Value',
      dataIndex: 'sumOfTCV',
      key: 'sumOfTCV',
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
        )
        }
    },
    {
      title: 'Revenue For Period',
      dataIndex: 'revenue',
      key: 'revenue',
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
        )
        }
    },
    {
        title: 'Total Revenue',
        dataIndex: 'totalRevenue',
        key: 'totalRevenue',
        render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
        }
      },
      {
        title: 'OBO Value',
        dataIndex: 'obo',
        key: 'obo',
        render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
        }
      }
  ];

  return (
    <Spin spinning={loading}>
      {/* Parent Opportunity Table */}
      <div style={{ marginBottom: '16px' }}>
        <Table
          dataSource={[parentSOW]} // Wrap parentSOW in an array to display as a single row
          columns={parentColumns}
          className='table-styles opportunity-details-table-container'
          rowKey={(record) => record.opportunityID}
          pagination={false}
          style={{
            borderRadius: '10px',
          }}
        //   bordered
        />
      </div>

      {/* SOW Details Section */}

        <div style={{ marginBottom: '16px' }}><span className='header-obo'> Work Order</span> <span className='obo-count-label'>{parentSOW.countOfWorkOrder} </span></div>
      {<Table
        dataSource={woData}
        columns={woColumns}
        rowKey={(record) => record.sowID}
        className='table-styles obo-table-sow-details'
        pagination={{
          current: pageNo + 1,
          pageSize,
          total: totalCount,
          showSizeChanger: false,
        }}
        onChange={handleTableChange}
      />}
    </Spin>
  );
};
export default OboWODetailsTableContainer;